// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/collection/collection-bulk-action-header/collection-bulk-action.component.scss
// module id = 141
// module chunks = 0